import {
  createContext,
  useContext,
  ReactNode,
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import { useApp } from "./AppContext";

/**
 * achievement notification type
 */
export interface Achievement {
  id: string;
  title: string;
  description: string;
  icon?: React.ReactElement;
  color?: string; // hex color for squircle background, default #ffcc00
  timeout?: number; // milliseconds, default 5000
}

/**
 * achievement in the queue with tracking
 */
interface AchievementItem extends Achievement {
  displayId: string; // unique id for this display instance
}

/**
 * quest achievement mapping - maps quest ids to achievement display data
 */
const questAchievements: Record<string, Omit<Achievement, "id">> = {
  meet_geoff: {
    title: "Met Geoff! 🧇",
    description: "Found out Geoff's favourite breakfast",
    color: "#f4a460",
    timeout: 5000,
  },
  find_jane: {
    title: "Found Jane! 💻",
    description: "Located Jane and got some help",
    color: "#87ceeb",
    timeout: 5000,
  },
  unlock_cats: {
    title: "Unlocked Cats! 🐱",
    description: "Got access to the neko application",
    color: "#ff9999",
    timeout: 5000,
  },
};

export interface AchievementContextType {
  achievements: AchievementItem[];
  showAchievement: (achievement: Achievement) => void;
  removeAchievement: (displayId: string) => void;
}

const AchievementContext = createContext<AchievementContextType | undefined>(undefined);

export function useAchievement() {
  const context = useContext(AchievementContext);
  if (!context) {
    throw new Error("useAchievement must be used within an AchievementProvider");
  }
  return context;
}

export default function AchievementProvider({ children }: { children: ReactNode }) {
  const { sessionReady, onMessage } = useApp();
  const [achievements, setAchievements] = useState<AchievementItem[]>([]);
  const idCounterRef = useRef(0);

  // show achievement notification
  const showAchievement = useCallback((achievement: Achievement) => {
    // const displayId = `achievement-${++idCounterRef.current}`;
    // // add to queue (timeout handling is done in the Achievements component)
    // setAchievements((prev) => [
    //   ...prev,
    //   { ...achievement, displayId },
    // ]);
  }, []);

  // remove achievement
  const removeAchievement = useCallback((displayId: string) => {
    // // remove from state
    // setAchievements((prev) => prev.filter((a) => a.displayId !== displayId));
  }, []);

  // listen for quest completion messages
  // useEffect(() => {
  //   if (!sessionReady) return;

  //   const unsub = onMessage("quest_list", (data: any) => {
  //     if (data.payload?.quests) {
  //       // check for newly completed quests
  //       const quests = data.payload.quests;

  //       quests.forEach((quest: any) => {
  //         if (quest.status === "completed") {
  //           const achievementData = questAchievements[quest.id];
  //           if (achievementData) {
  //             showAchievement({
  //               id: quest.id,
  //               ...achievementData,
  //             });
  //           }
  //         }
  //       });
  //     }
  //   });

  //   return unsub;
  // }, [sessionReady, onMessage, showAchievement]);

  return (
    <AchievementContext.Provider value={{ achievements, showAchievement, removeAchievement }}>
      {children}
    </AchievementContext.Provider>
  );
}
